export const TipoUsuario = Object.freeze({
  ADMIN: "ADMIN",
});
